/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { ModalButton } from './ModalButton';
import { Typography, MenuItem } from '@mui/material';
import {
  CustomTextField,
  SelectDropdown,
  SuccessModal,
  GeneralModal,
} from '../index';
import { apiUrl } from '../../utilities/apiUrl';
import { useEffect, useState } from 'react';

export const EditEmpModal = (props) => {
  const [lastname, setLastname] = useState(props.lastname);
  const [firstname, setFirstname] = useState(props.firstname);
  const [username, setUsername] = useState(props.username);
  const [role, setRole] = useState('REGULAR_USER');
  const [editSuccessOpen, setEditSuccessOpen] = useState(false);

  // Wait for props to update
  useEffect(() => {
    setLastname(props.lastname);
    setFirstname(props.firstname);
    setUsername(props.username);
    setRole(props.role);
  }, [props.lastname, props.firstname, props.username, props.role]);
  // EDIT EMPLOYEE RECORD HANDLER
  const handleEdit = () => {
    fetch(apiUrl('/employee/' + props.selectedEmp), {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: username,
        firstname: firstname,
        lastname: lastname,
        role: role,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          setEditSuccessOpen(true);
        } else {
          alert(data.message);
        }
      });
  };

  // SUCCESSFULLY EDITED EMPLOYEE MODAL
  const handleEditSuccessClose = () => {
    setEditSuccessOpen(false);
    // reset values
    setLastname(null);
    setFirstname(null);
    setUsername(null);
    setRole('REGULAR_USER');
    window.location.reload();
  };

  return (
    <>
      <GeneralModal open={props.open} onClose={props.onClose}>
        <Typography sx={{ mb: 3, fontWeight: 600 }} variant="h5">
          Edit employee details:
        </Typography>
        <CustomTextField
          error={!firstname}
          errorMsg={'Please enter a first name'}
          required={true}
          label="First Name"
          defaultValue={props.firstname}
          onChange={(event) => {
            setFirstname(event.target.value);
          }}
        />
        <CustomTextField
          error={!lastname}
          errorMsg={'Please enter a last name'}
          required={true}
          label="Last Name"
          defaultValue={props.lastname}
          onChange={(event) => {
            setLastname(event.target.value);
          }}
        />
        <CustomTextField
          error={!username}
          errorMsg={'Please enter a username'}
          required={true}
          label="Username"
          defaultValue={props.username}
          onChange={(event) => {
            setUsername(event.target.value);
          }}
        />

        <SelectDropdown
          fullWidth={true}
          require={true}
          margin="normal"
          label="Role"
          defaultValue={props.role}
          onChange={(event) => {
            setRole(event.target.value);
          }}
        >
          <MenuItem value={'REGULAR_USER'}>Regular User</MenuItem>
          <MenuItem value={'ADMIN'}>Admin</MenuItem>
          <MenuItem disabled value={'SUPER_ADMIN'}>
            Super Admin
          </MenuItem>
        </SelectDropdown>

        <ModalButton
          primaryBtnName="Save"
          secondaryBtnName="Cancel"
          primaryClickHandler={() => {
            handleEdit();
            props.onClose();
          }}
          secondaryClickHandler={props.onClose}
          disable={!firstname || !lastname || !username}
        />
      </GeneralModal>
      <SuccessModal
        open={editSuccessOpen}
        onClose={() => {
          setEditSuccessOpen(false);
          handleEditSuccessClose();
        }}
        close={handleEditSuccessClose}
        desc={'You have successfully edited an employee record.'}
      />
    </>
  );
};
